import { __assign } from 'tslib';
import { number } from 'style-value-types';

var int = __assign(__assign({}, number), { transform: Math.round });

export { int };



//////////////////
// WEBPACK FOOTER
// ./node_modules/framer-motion/dist/es/render/dom/value-types/type-int.mjs
// module id = 9nAT
// module chunks = 0